"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var shared_1 = require("@formily/shared");
exports.useDirty = function (input, keys) {
    if (input === void 0) { input = {}; }
    if (keys === void 0) { keys = []; }
    var ref = react_1.default.useRef({ data: __assign({}, input), dirtys: {}, num: 0 });
    ref.current.num = 0;
    keys.forEach(function (key) {
        if (!shared_1.isEqual(input[key], ref.current.data[key])) {
            ref.current.data[key] = input[key];
            ref.current.dirtys[key] = true;
            ref.current.num++;
        }
        else {
            ref.current.dirtys[key] = false;
        }
    });
    return ref.current;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react/lib/hooks/useDirty.js
// module id = 5762
// module chunks = 0